import { Container, Flex, Spinner, VStack } from "@chakra-ui/core";
import React, { useEffect, useState } from "react";
import Post from "./components/post";
import Navbar from "./components/navbar";
// import db from "./lib/firebase";

const App = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const url = "https://social-media-app.divyachalla95.workers.dev/posts";

    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const json = await response.json();
        console.log(json);
        setPosts(json);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  const refreshPage = () => {
    window.location.reload(false);
  }

  let postList = posts.sort((a,b) => {
    return ((a.upVotesCount - a.downVotesCount) > (b.upVotesCount - b.downVotesCount)) ? -1:1
  })

  return (
    <>
      <Navbar posts={posts} refreshPage={refreshPage}/>
      <Container maxW="lg" centerContent p={8}>
        <VStack spacing={8} w="100%">
          {postList.map((post) => (
            <Post post={post} key={post.id} posts={posts} refreshPage={refreshPage} />
          ))}
        </VStack>
      </Container>
    </>
  );
};

export default App;